export default __webpack_public_path__ + "static/media/logo30.473278be.png";